import BankTransfer from 'components/Shared/Icons/BankTransfer';
import {
  BankTransferSurcharge,
  CreditCard,
  CreditCardSurcharge,
} from 'components/Shared/Icons/Icons';
import { FeatureFlags } from 'types/FeatureFlags';
import { Sale } from 'types/Sale';
import {
  SURCHARGE_MAP,
  SURCHARGE_FF_KEY,
  SURCHARGE_INELIGIBLE_PAYMENT_METHODS,
} from 'types/constants';

// Todo: this function to be updated when we add connect the surcharging API
export function filterSurchargeEligibleMethods(
  paymentMethodsOrder: string[],
  isSurchargingEnabled: boolean
): string[] {
  if (isSurchargingEnabled) {
    return paymentMethodsOrder.filter(
      (method) => !SURCHARGE_INELIGIBLE_PAYMENT_METHODS.includes(method)
    );
  }
  return paymentMethodsOrder;
}

export function isSurchargeEnabled(
  sale: Sale | null | undefined,
  featureFlags: FeatureFlags
): boolean {
  return Boolean(featureFlags?.[SURCHARGE_FF_KEY]);
}

export function getPayWithMessages(isSurchargingEnabled: boolean) {
  if (isSurchargingEnabled) {
    return {
      bankMessageId: 'PAYNOW_PAYNOW_PAY_WITH_BANK_TRANSFER_SURCHARGE',
      bankDefaultMessage: 'Pay with bank transfer (+{feePercent}%)',
      ccMessageId: 'PAYNOW_PAYNOW_PAY_WITH_CREDIT_CARD_SURCHARGE',
      ccDefaultMessage: 'Pay with credit card (+{feePercent}%)',
    };
  }
  return {
    bankMessageId: 'PAYNOW_PAYNOW_PAY_WITH_BANK_TRANSFER',
    bankDefaultMessage: 'Pay with bank transfer',
    ccMessageId: 'PAYNOW_PAYNOW_PAY_WITH_CREDIT_CARD',
    ccDefaultMessage: 'Pay with credit card',
  };
}

export function getPaymentMethodSurchargeConfig(isSurchargingEnabled: boolean) {
  if (isSurchargingEnabled) {
    return {
      bankIcon: BankTransferSurcharge,
      ccIcon: CreditCardSurcharge,
      bankSurchargeLabel: `+${SURCHARGE_MAP.ACH_FEE_LABEL}%`,
      ccSurchargeLabel: `+${SURCHARGE_MAP.CC_FEE_LABEL}%`,
    };
  }
  return {
    bankIcon: BankTransfer,
    ccIcon: CreditCard,
    bankSurchargeLabel: undefined,
    ccSurchargeLabel: undefined,
  };
}
